import { Button } from "@tellescope/design-system";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { DropdownMenuItem } from "@tellescope/ui";
import { LucideIcon } from "lucide-react";
import { ComponentProps } from "react";
import { Link } from "react-router-dom";

// TODO: create a "menu item" abstraction (maybe co-located with the migrated dropdowm menu)
// TODO: also consider creating a polymorphism abstraction in `react-utils`
export interface HeaderMenuItemProps
  extends Omit<ComponentProps<typeof DropdownMenuItem>, "onClick" | "icon" | "label" | "loading" | "hidden"> {
  icon?: LucideIcon;
  label: string;
  onClick: (() => void) | { to: string; replace?: boolean };
  loading?: boolean;
  hidden?: boolean | ((enduser: TellescopeModelFromName<"endusers">) => boolean);
}

export const HeaderMenuItem = ({
  icon: Icon,
  label,
  onClick,
  loading = false,
  asChild = true,
  hidden = false,
  ...rest
}: HeaderMenuItemProps) => {
  const Component = typeof onClick === "function" ? Button : Link;

  if (hidden) {
    return null;
  }

  return (
    <DropdownMenuItem {...rest} asChild={asChild}>
      <Component
        onClick={typeof onClick === "function" ? onClick : undefined}
        to={typeof onClick === "object" ? onClick.to : ""}
        replace={typeof onClick === "object" ? onClick.replace : undefined}
        loading={typeof onClick === "function" ? loading : undefined}
        variant={typeof onClick === "function" ? "ghost" : undefined}
      >
        {!!Icon && <Icon />}
        {label}
      </Component>
    </DropdownMenuItem>
  );
};
